<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" title="로그 패턴 설정" width="600px" @close="close">
      <div slot="content">
        <div class="title-bar">
          <div class="title-h4">패턴 기본 정보</div>
        </div>
        <el-form :model="patternData" label-position="top" ref="patternForm" :rules="rules">
          <el-row>
            <el-form-item label="패턴 명" prop="mlPatternName">
              <el-input v-model="patternData.mlPatternName" placeholder="패턴명 미설정"/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="패턴" prop="mlPattern">
              <el-input
                type="textarea"
                :rows="3"
                :readonly="true"
                v-model="patternData.mlPattern">
              </el-input>
            </el-form-item>
          </el-row>
          <el-form-item label="패턴 로그 목록">
            <span slot="label">
              <span class="mr-r4">패턴 로그 목록</span>
              <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
                <span class="text"> - 패턴이 등록된 후 발생한 로그 목록입니다. <br/> - 현재부터 <em>최근 30일 </em>까지의 로그를 조회합니다.</span>
                <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
              </el-popover>
            </span>
          </el-form-item>
          <el-row v-loading="loading">
            <el-table-wrapper ref="logTable" :column-default="columnDefault" :data="logTableData" :columns="logColumns" @condition-change="changeCondition" pagination
            highlight-current-row :show-custom-header="false" :show-search-tool="false" :total="total" header-align="center" remote>
            </el-table-wrapper>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="large" type="solid" @click="settingPattern">저장</el-button>
        <el-button @click="close" size="large" >취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { cloneDeep, isNil } from 'lodash';
import LmsMlAPI from '@/api/settings/log/lms-machine-learning-setting';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WLogPatternSettingPopup',
  props: {
    selectedLogid: {
      type: Object,
    },
    mlFlag: {
      type: Boolean,
    },
    selectedPattern: {
      type: Object,
    },
  },
  data() {
    const validatePatterName = (rule, value, callback) => {
      if (isNil(value) || value.length === 0) {
        callback(new Error('필수 정보입니다.'));
      } else if (value.length > 125) {
        callback(new Error(msgUtil.getStringLengthValidationMsgData(125)));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      columnDefault,
      logTableData: [],
      start: 0,
      limit: 50,
      total: 0,
      logColumns: [
        {
          label: '로그 메시지',
          prop: 'originMessage',
        },
      ],
      patternData: {
        mlPattern: '',
        mlPatternName: '',
      },
      rules: {
        mlPatternName: [
          { required: true, validator: validatePatterName, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    /**
     * 미확인 로그 패턴 설정 저장 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    settingPattern() {
      this.$refs.patternForm.validate().then((success) => {
        if (success) {
          const params = this.patternData;
          LmsMlAPI.updateMachineLearning(params).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '패턴', true));
              this.close();
              this.$emit('loadData');
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '패턴', false));
            }
          }).catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '패턴', false));
            throw new Error(e);
          });
        }
      });
    },
    /**
     * 선택한 머신러닝 패턴의 원시 로그 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadLogData() {
      const date = new Date();
      const queryList = [
        {
          field: 'mlPatternId',
          operator: 'AND',
          regex: 'N',
          value: this.selectedPattern.mlPatternId,
        },
      ];
      const endDateTime = date.getTime();
      const startDateTime = date.setDate(date.getDate() - 30);
      const params = {
        type: 'dataindex',
        dataindexId: this.selectedLogid.dataindexId,
        start: this.start,
        limit: this.limit,
        startDateTime,
        endDateTime,
        queryList,
      };
      this.loading = true;
      LmsMlAPI.getMlLogList(params).then((response) => {
        if (response.data.success) {
          this.logTableData = response.data.data;
          this.total = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    changeCondition(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.loadLogData();
    },
    open() {
      this.loading = false;
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.$refs.logTable.setCurrentPage(1);
        this.patternData = cloneDeep(this.selectedPattern);
        if (this.patternData.mlPatternName === '패턴명 미설정') {
          this.patternData.mlPatternName = null;
        }
      });
    },
    close() {
      this.$refs.patternForm.resetFields();
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Pattern/popup/LogPatternSettingPopup.vue